import React, { useEffect, useMemo, useState } from 'react'
// import { SlEye } from 'react-icons/sl'
// import { FaPlus } from 'react-icons/fa6'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import { Avatar, Button, Divider, Drawer, Dropdown, Form, Image, Input, Modal, Select, Space, Tag, Upload, notification } from 'antd'
import eventImage from '../../../assets/gallery/event.png'
import { handleConfirm, handleTableSelect, statusType } from '../../../context/utils'
import CustomTable from '../../../components/CustomTable'
// import { PiDotsThreeOutlineBold } from 'react-icons/pi'
// import { BiEdit, BiUser } from 'react-icons/bi'
import { LuFileUp } from 'react-icons/lu'
// import { GoTrash } from 'react-icons/go'
import { ImStopwatch } from 'react-icons/im'
import { CiCalendarDate, CiLocationOn } from 'react-icons/ci'
import { useDeleteBrand } from '../../../hooks/brands/brands'
// import { useGetProducts } from '../../../hooks/products/products'
import { useGetModels } from '../../../hooks/model/model'
import { useGetDevice, useGetDevices, usePatchDevice, usePostDevice } from '../../../hooks/devices/devices'
import { useGetProductColors } from '../../../hooks/productColor/productColor'
import SearchPage from '../../../components/searchPage'
import FilterModal from '../../../components/FilterModal'

function DevicesTab() {
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('')
  // const [page, setPage] = useState(0)
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [openFilter, setOpenFilter] = useState(false)
  const [isViewOpen, setIsViewOpen] = useState(false)
  const [image, setImage] = useState({})
  const onCreateOpen = () => setIsCreateOpen(true)
  const onViewClose = () => setIsViewOpen(false)
//   const onViewOpen = () => setIsViewOpen(true)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const onOpenEdit = () => setIsOpenEdit(true)
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()

  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
    setRows([])
  }
  
  const onCloseEdit = () => {
    setIsOpenEdit(false)
    form.resetFields();
  }
   
  const [createPayload, setCreatePayload] = useState({ 
    serialNumber: "",
    price: 0,
    productIds: "",
    modelId: "",
    // imageFile: "",
    receiptImage: "",
    id:"",
    imeiNumber1:"",
    imeiNumber2:"",
  })

  const {
    data: getDevicesData,
    refetch: getDevicesFetch,
    isFetching: getDevicesLoad,
  } = useGetDevices(
    {SearchString: search, productStatusId: status},
    ["SearchString", "productStatusId"],
  )
  
const {
  data: getProductsData,
  isFetching: getProductsLoad,
} = useGetProductColors()
  
const {
  data: getModelData,
  isFetching: getModelLoad,
} = useGetModels()

const {
  data: getData,
  mutate: getAction,
  isLoading: getLoad,
} = useGetDevice(onOpenEdit)

const successAction = () => {
  form.resetFields();
  getDevicesFetch();
};

  useEffect(() => {
    setCreatePayload({      
      serialNumber:   getData?.data?.serialNumber || "",
      price: getData?.data?.price || 0,
      productIds:   getData?.data?.productStatus?.id || [],
      modelId:   getData?.data?.model?.id || [],
      imageFile:   getData?.data?.imageFile || "",
      receiptImage:   getData?.data?.receiptImage || "",
      id:  getData?.data?.id || "",
      imeiNumber1:  getData?.data?.imeiNumber1 || "",
      imeiNumber2:  getData?.data?.imeiNumber2 || "",
    })
    
  }, [getData?.data])

  const uploadProps = useMemo(() => ({
    name: 'file',
    method: 'GET',
    multiple: false,
    data: image?.file,
    onChange({file, fileList}) {
      setImage({
        file,
        name: file?.name,
        fileObj: file?.originFileObj,
        url: URL.createObjectURL(file?.originFileObj),
      })
      // setCreatePayload({...createPayload, imageFile: file?.originFileObj})
    }
  }), [image]);

  const {
    mutate: postAction,
    isLoading: postLoad,
  } = usePostDevice(successAction)

  const {
    mutate: putAction,
    isLoading: putLoad,
  } = usePatchDevice(successAction)
  
  const {
    mutate: deleteAction,
    isLoading: deleteLoad,
  } = useDeleteBrand(successAction)

  const handleEdit = (d) => {    
    getAction(d.id)
  }

  const columns = [
    {
      title: "Model Name",
      dataIndex: "model",
      key:"1",
      render: (e) => <div className='flex items-center gap-3'>
        {/* <Avatar src="">{e?.charAt(0)}</Avatar> */}
        <p className='text-sm font-medium text-dim'>{e?.name}</p>
      </div>,
    },
    {
      title: "Product Status",
      dataIndex: "productStatus",
      key:"2",
      render: (e) => 
      <p>{e?.name}</p>
    },
    {
      title: "Price",
      dataIndex: "price",
      key:"price",
    },
    {
      title: "Serial Number",
      dataIndex: "serialNumber",
      key:"serialNumber",
      render: (e) => 
      <p>{e ? e : 'N/A'}</p>
    },
    {
      title: "Imei Number 1",
      dataIndex: "imeiNumber1",
      key:"imeiNumber1",
      render: (e) => 
        <p>{e ? e : 'N/A'}</p>
    },
    {
      title: "Imei Number 2",
      dataIndex: "imeiNumber2",
      key:"imeiNumber2",
      render: (e) => 
        <p>{e ? e : 'N/A'}</p>
    },
    {
      title: "Receipt Image",
      dataIndex: "receiptImageUrl",
      key:"3",
      render: (e) => 
        <Image src={e} alt='vRV' width={70} />
    },
    // {
    //   title: "Action",
    //   dataIndex: "",
    //   render: (data,idx) => <Dropdown
    //     key={idx}
    //     trigger={["click"]}
    //     placement="bottomLeft"
    //     menu={{items: [
    //       // {key: "view", icon: <SlEye className='!text-base' />, label: <button id=''>View</button>},
    //       {key: "edit", label: <button className='flex hidden' onClick={()=>handleEdit(data)}><BiEdit className='!text-base mx-4 py-auto' /> Edit</button>},
    //       // {key: "delete", icon: <GoTrash className='!text-base mx-4 py-auto' />, label: <button onClick={() => handleConfirm({})}>Delete</button>},
    //       {key: "delete", label: <button className='flex' onClick={() => handleConfirm({data: data?.id, action: deleteAction})}><GoTrash className='!text-base mx-4 py-auto' /> Delete</button>},

    //     ]}}
    //   >
    //     <Button loading={getLoad || deleteLoad} className='!bg-[#F2F6FC]' type='text' icon={<PiDotsThreeOutlineBold />} />
    //   </Dropdown>
    // },
  ]
  const onSubmit = (d) => {
    if (!image?.fileObj) {
      notification.error({
        message: "Failed!",
        description: "Please Image is Required",
      })
    }else{
      const payload = {          
            serialNumber: d.serialNumber,
            price: d.price,
            productStatusId: d.productIds,
            modelId: d.modelIds,
            // imageFile: "",
            receiptImage: image?.fileObj,
            imeiNumber1: d.imeiNumber1,
            imeiNumber2: d.imeiNumber2,
        }
        postAction(payload)
        console.log(payload)
    }
  }
  const onSubmitEdit = () => {
    putAction(createPayload)
    console.log(createPayload)
  }

  return (
    <PadContainer loading={getDevicesLoad || getProductsLoad || getModelLoad}>
      <TitleContainer
        path={false}
        title="Devices Management"
        className="border border-lit rounded-xl"
        // action={<Button onClick={onCreateOpen} className='!bg-light_blue hidden' type='primary' size='large' icon={<FaPlus />}>Add Device</Button>}
        action={
          <div className='flex'>
            <SearchPage setSearch={setSearch} size='' />
            <Button size='large' onClick={() => setOpenFilter(true)} className='!bg-light_blue mx-2' type='primary'>Filter</Button>
          </div>
        }
      >
        <CustomTable
          pagination={10}
          column={columns}
          data={getDevicesData?.data?.data}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
      </TitleContainer>

      <FilterModal
        setOpenFilter={setOpenFilter}
        openFilter={openFilter}
        getProductsData={getProductsData?.data?.data}
        setStatus={setStatus}
      />

      {/* create edit drawer */}
      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>New Device</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
          <Form.Item label="Models" name="modelIds" required>
            <Select size='large' placeholder='Select Model'>              
              {getModelData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Products" name="productIds" required>
            <Select size='large' placeholder='Select Products'>              
              {getProductsData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item label="Price" name="price" className='' required>
              <Input size='large' className='!w-full' />
            </Form.Item>
            <Form.Item label="Serial Number" name="serialNumber" className='' required>
              <Input size='large' className='!w-full' />
            </Form.Item>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item label="Imei Number(1)" name="imeiNumber1" className=''>
              <Input size='large' className='!w-full' />
            </Form.Item>
            <Form.Item label="Imei Number(2)" name="imeiNumber2" className=''>
              <Input size='large' className='!w-full' />
            </Form.Item>
          </div>
          {/* <Form.Item label="Description" name="description">
            <Input.TextArea placeholder='Enter description' size='large' rows={4} />
          </Form.Item> */}serialNumber
          <Form.Item>
            <Upload {...uploadProps}>
              <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
            </Upload>
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={postLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      <Drawer
        open={isOpenEdit}
        onClose={onCloseEdit}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit Device</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
        >
          <Form.Item label="Models" required>    
            <Select 
                size='large' 
                placeholder='Select Model' 
                // mode="multiple"
                value={createPayload.modelId}
                onChange={(value)=> setCreatePayload({...createPayload, modelId: value})}
            >
            {getModelData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
            ))}
            </Select>
          </Form.Item>
          <Form.Item label="Products" required>        
            <Select 
                size='large' 
                placeholder='Select Categories' 
                // mode="multiple"
                value={createPayload.productIds}
                onChange={(value)=> setCreatePayload({...createPayload, productIds: value})}
            >
            {getProductsData?.data?.data.map((e)=>(
                <Select.Option value={e.id}>{e.name}</Select.Option>
            ))}
            </Select>
          </Form.Item>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item label="Price" className='' required>
              <Input 
                size='large' 
                className='!w-full'
                value={createPayload.price}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, price: value})}
              />
            </Form.Item>
            <Form.Item label="Serial Number" className='' required>
              <Input 
                size='large' 
                className='!w-full'
                value={createPayload.serialNumber}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, serialNumber: value})} 
              />
            </Form.Item>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
            <Form.Item label="Imei Number(1)" className=''>
              <Input 
                size='large' 
                className='!w-full' 
                value={createPayload.imeiNumber1}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, imeiNumber1: value})}
              />
            </Form.Item>
            <Form.Item label="Imei Number(2)" className=''>
              <Input 
                size='large' 
                className='!w-full'
                value={createPayload.imeiNumber2}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, imeiNumber2: value})} 
             />
            </Form.Item>
          </div>
          <Form.Item>
            <Upload {...uploadProps}>
              <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
            </Upload>
            {createPayload.receiptImage &&
              <Image src={createPayload.receiptImage} />
            }
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={putLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Update</Button>
          </div>
        </Form>
      </Drawer>

      {/* view drawer */}
      <Drawer
        open={isViewOpen}
        onClose={onViewClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Brands</p>}
      >
        <div className='w-full'>
          <div className='flex gap-3 items-center'>
            <Image alt='Brands image' src={eventImage} />
            <div className='space-y-3'>
              <p className='text-2xl font-bold text-light_blue'>Kings’s Day Parade</p>
              <Tag className={`${statusType?.info?.bg} ${statusType?.secondary?.col} ${statusType?.info?.bd} font-bold rounded-2xl px-3 py-0.5`}>Active</Tag>
            </div>
          </div>
          <Divider />
          <div className='w-full rounded-xl bg-[#FEFAF2] px-5 divide-y'>
            {[
              {Icon: CiLocationOn, value: "Mandeville"},
              {Icon: ImStopwatch, value: "2pm"},
              {Icon: CiCalendarDate, value: "12 December, 2023"},
            ].map(({Icon, value}) => (
              <div className='flex items-center gap-3 py-5'>
                <Button className='!bg-[#FDE9C2] !text-[#F5A302]' icon={<Icon className="!text-xl" />} shape='circle' size='large' type='primary' />
                <p className='text-lg font-semibold text-silver'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            {[
              {label: "Route From", value: "Lagos"},
              {label: "Route To", value: "Germany"},
              {label: "Category", value: "Music and Entertainment"},
              {label: "Created by", value: "Admin"},
            ].map(({label, value}) => (
              <div className='flex items-center gap-3'>
                <p className='text-base text-light_blue font-semibold'>{label}: </p>
                <p className='text-base text-dim font-medium'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 flex justify-between items-center'>
            <div className='flex items-center gap-5'>
              <p className='text-base text-light_blue font-semibold'>Attendees:</p>
              <Avatar.Group
                maxCount={4}
                maxPopoverTrigger="click"
                maxStyle={{ color: '#F5A302', backgroundColor: '#002C70', cursor: 'pointer' }}
              >
                {Array.from(Array(100).keys()).map(idx => (
                  <Avatar>{idx}</Avatar>
                ))}
              </Avatar.Group>
            </div>
            <Button className='!bg-lint text-dim' type='primary' size='small'>View All</Button>
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            <p className='text-base text-light_blue font-semibold'>Description</p>
            <p className='text-sm text-dim font-normal'>Celebrate the vibrant spirit of our community at our annual Parade Spectacular! Join us for a lively and colourful procession weaving through the heart of [City/Town Name], featuring magnificent floats, marching bands, and dazzling performances.</p>
          </div>
          <Divider />
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={handleEdit} loading={false} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Edit</Button>
            <Button className='!text-light_blue !border-light_blue' size='large'>Delete</Button>
          </div>
        </div>
      </Drawer>
    </PadContainer>
  )
}

export default DevicesTab